import { lazyNamed } from './lazyNamed';

/** Route-level lazy page components (named exports from feature modules). */
export const routePages = {
  HomePage: lazyNamed(() => import('../features/home/HomePage'), 'HomePage'),
  TeamPage: lazyNamed(() => import('../features/team/TeamPage'), 'TeamPage'),
  AdminNewsPage: lazyNamed(
    () => import('../features/news/AdminNewsPage/AdminNewsPage'),
    'AdminNewsPage'
  ),
  AdminAddChangeNewsPage: lazyNamed(
    () =>
      import('../features/news/AdminAddChangeNewsPage/AdminAddChangeNewsPage'),
    'AdminAddChangeNewsPage'
  ),
  AdminHolidayCalendarPage: lazyNamed(
    () => import('../features/holidays/AdminHolidayCalendarPage'),
    'AdminHolidayCalendarPage'
  ),
  AdminAddChangeHolidayCalendarPage: lazyNamed(
    () => import('../features/holidays/AdminAddChangeHolidayCalendarPage'),
    'AdminAddChangeHolidayCalendarPage'
  ),
  MoviesPage: lazyNamed(
    () => import('../features/movies/MoviesPage'),
    'MoviesPage'
  ),
  LearnPage: lazyNamed(
    () => import('../features/learn/LearnPage'),
    'LearnPage'
  ),
  FeedNewsPage: lazyNamed(
    () => import('../features/news/FeedNewsPage/FeedNewsPage'),
    'FeedNewsPage'
  ),
  FeedSeparateNewsPage: lazyNamed(
    () => import('../features/news/FeedSeparateNewsPage/FeedSeparateNewsPage'),
    'FeedSeparateNewsPage'
  ),
  CompanyMarketingNewsPage: lazyNamed(
    () =>
      import('../features/news/CompanyMarketingNewsPage/CompanyMarketingNewsPage'),
    'CompanyMarketingNewsPage'
  ),
  CompanySeparateNewsPage: lazyNamed(
    () =>
      import('../features/news/CompanySeparateNewsPage/CompanySeparateNewsPage'),
    'CompanySeparateNewsPage'
  ),
  MarketingSeparateNewsPage: lazyNamed(
    () =>
      import('../features/news/MarketingSeparateNewsPage/MarketingSeparateNewsPage'),
    'MarketingSeparateNewsPage'
  ),
  AdminCompanyMarketingNewsPage: lazyNamed(
    () =>
      import('../features/news/AdminCompanyMarketingNewsPage/AdminCompanyMarketingNewsPage'),
    'AdminCompanyMarketingNewsPage'
  ),
  AdminAddChangeCompanyMarketingNewsPage: lazyNamed(
    () =>
      import('../features/news/AdminAddChangeCompanyMarketingNewsPage/AdminAddChangeCompanyMarketingNewsPage'),
    'AdminAddChangeCompanyMarketingNewsPage'
  ),
  GalleryPage: lazyNamed(
    () => import('../features/gallery/GalleryPage'),
    'GalleryPage'
  ),
  AdminGalleryPage: lazyNamed(
    () => import('../features/gallery/AdminGalleryPage'),
    'AdminGalleryPage'
  ),
  GallerySeparatePage: lazyNamed(
    () => import('../features/gallery/GallerySeparatePage'),
    'GallerySeparatePage'
  ),
  AdminAddChangeGalleryPage: lazyNamed(
    () => import('../features/gallery/AdminAddChangeGalleryPage'),
    'AdminAddChangeGalleryPage'
  ),
  AdminMailingListPage: lazyNamed(
    () => import('../features/mailing/AdminMailingListPage'),
    'AdminMailingListPage'
  ),
  LogsPage: lazyNamed(() => import('../features/logs/LogsPage'), 'LogsPage'),
  ErrorPage: lazyNamed(
    () => import('../features/error/ErrorPage'),
    'ErrorPage'
  ),
  TestPage: lazyNamed(() => import('../features/test/TestPage'), 'TestPage'),
  AdminShopPage: lazyNamed(
    () => import('../features/shop/AdminShopPage'),
    'AdminShopPage'
  ),
  ShopProductPage: lazyNamed(
    () => import('../features/shop/ShopProductPage'),
    'ShopProductPage'
  ),
  ShopPage: lazyNamed(() => import('../features/shop/ShopPage'), 'ShopPage'),
  AdminShopProductPage: lazyNamed(
    () => import('../features/shop/AdminShopProductPage'),
    'AdminShopProductPage'
  ),
  AdminVariantsPage: lazyNamed(
    () => import('../features/shop/AdminVariantsPage/AdminVariantsPage'),
    'AdminVariantsPage'
  ),
  AdminVariantPage: lazyNamed(
    () => import('../features/shop/AdminVariantPage/AdminVariantPage'),
    'AdminVariantPage'
  ),
  AdminVariantAdd: lazyNamed(
    () => import('../features/shop/AdminVariantsPage/AdminVariantAdd'),
    'AdminVariantAdd'
  ),
  ShopOrdersPage: lazyNamed(
    () => import('../features/shop-orders/ShopOrdersPage'),
    'ShopOrdersPage'
  ),
  UserOrdersPage: lazyNamed(
    () => import('../features/shop-orders/UserOrdersPage'),
    'UserOrdersPage'
  ),
  AdminShopOrders: lazyNamed(
    () => import('../features/shop-orders/AdminShopOrders'),
    'AdminShopOrders'
  ),
  AdminShopOrdersPage: lazyNamed(
    () => import('../features/shop-orders/AdminShopOrdersPage'),
    'AdminShopOrdersPage'
  ),
  AdminCoins: lazyNamed(
    () => import('../features/coins/AdminCoins'),
    'AdminCoins'
  ),
  CoinProposalFormPage: lazyNamed(
    () => import('../features/coin-proposals/CoinProposalFormPage'),
    'CoinProposalFormPage'
  ),
  CoinProposalsAdminPage: lazyNamed(
    () => import('../features/coin-proposals/CoinProposalsAdminPage'),
    'CoinProposalsAdminPage'
  ),
  MassRewardPage: lazyNamed(
    () => import('../features/mass-reward/MassRewardPage'),
    'MassRewardPage'
  ),
  AdminCompanyStructure: lazyNamed(
    () => import('../features/company-structure/AdminCompanyStructure'),
    'AdminCompanyStructure'
  ),
  AdminMerchReportPage: lazyNamed(
    () => import('../features/merch-report/AdminMerchReportPage'),
    'AdminMerchReportPage'
  ),
} as const;
